import { TournamentStatus } from '@repo/common-types';
import TournamentStatusBadge from '../../components/TournamentStatus';
import useTournamentStatusColor from '@/hooks/useTournamentStatusColor';

const TournamentStatusIndicator = ({ status }: { status: string }) => {
  const statusColor = useTournamentStatusColor(status);

  return (
    <div className="d-flex align-items-center justify-content-start gap-2">
      <div className={`bg-${statusColor} rounded-circle`} style={{ width: '15px', height: '15px' }} />
      <TournamentStatusBadge status={status as TournamentStatus} />
    </div>
  );
};

export default TournamentStatusIndicator;
